import React, { useContext, useEffect, useState } from 'react'
import { Key, PersonAdd } from 'react-bootstrap-icons'
import { BiUserPlus } from 'react-icons/bi'
import Access from '../../../../libs/api/services/Access'
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider'
import { ConsentModal } from '../../dashboards/Widgets/DashboardWidgetConsent'
import AccessModal from './AccessModal'

export default function PatientProfileSharedWith() {
    const { createModal, showError } = useContext(CommonFunctionsContext)

    const [requests, setRequests] = useState()
    const load = async () => setRequests(await Access.ListPendingRequests(true).catch(showError))
    useEffect(() => {
        load()
    }, [])


    const handleShowAccess = () => createModal(<AccessModal />, 'Access', <Key />)
    const handleRevoke = () => { }
    return (
        <div className='d-flex flex-column flex-grow-1'>
            <h2 className='text-center m-2'>Your information is currently being shared with</h2>
            <div className='m-2'>
                {requests && requests.map(request =>
                    <div
                        onClick={() => createModal(<ConsentModal request={request} onClosed={() => load()} />, "Consent", <BiUserPlus />)}
                        className='d-flex w-100 align-items-center justify-content-center ' key={request.id}>
                        <PersonAdd />
                        <div className='flex-grow-1'>
                            {request.shareWith.firstName} {request.shareWith.lastName}
                        </div>
                        {
                            {
                                "OVERRIDE": <button className='btn'>View</button>,
                                "REQUIRED": <button className='btn'>View</button>,
                                "NOTICE": <></>,
                            }[request.consentType]
                        }
                    </div>
                )}
            </div>
        </div>
    )
}
